export default __webpack_public_path__ + "6a4191674aa941e2ed083cd2a49f925f.png";